import { Injectable, Injector } from '@angular/core';
import { WidgetsQuestionModel } from 'src/app/models/widgets/widgets-question.model';
import { Logger } from 'src/app/core/logger';
import { Config } from 'src/app/config';
import { BehaviorSubject } from 'rxjs';
import { QuestionService } from '../api/question.service';

@Injectable({
  providedIn: 'root',
})
export class QuestionEditorService {
  // Globally store the root of the formWidget Tree in the service
  /* eslint-disable */
  private readonly _questionRoot = new BehaviorSubject<WidgetsQuestionModel>(QuestionEditorService.factory());
  public readonly questionRoot$ = this._questionRoot.asObservable();

  constructor(
    private injector: Injector,
    private logger: Logger,
    private questionService: QuestionService) {
    // Empty
  }

  /**
   * Getter for root Layout
   *
   * @returns Current value of the WidgetsFormModel layout
   */
  get root(): WidgetsQuestionModel {
    return this._questionRoot.getValue();
  }

  /**
   * Setter for root Layout
   *
   * @param form New Form to be the root layout will be
   */
  set root(form: WidgetsQuestionModel) {
    this._questionRoot.next(form);
  }


  /**
   * The initial form is created with default data and selected state
   */
  static factory(): WidgetsQuestionModel {
    const form = new WidgetsQuestionModel();
    form.isSelected = true;
    form.isEdit = false;
    form.createdBy = Config.user.iNumber;
    return form;
  }

  /**
   * Return the current Layout root tree
   *
   * @returns
   */
  public getQuestionRoot(): WidgetsQuestionModel {
    return this.root;
  }

  /**
   * Set the specified WidgetFormModel as the Layout tree root
   *
   * @param layoutRoot
   */
  public setLayoutRoot(newLayoutRoot: WidgetsQuestionModel) {
    // Let a subscription do this...
    // this.rebuildDropListIds(newLayoutRoot);

    // New layout is replaced
    this.root = newLayoutRoot;
  }
}
